import { defineMessages } from 'react-intl';

export default defineMessages({
    orderInformation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Order Information',
        defaultMessage: 'Order Information'
    },
    nameOfInsured: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.NAME OF INSURED',
        defaultMessage: 'NAME OF INSURED'
    },
    returnAddress: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.RETURN ADDRESS',
        defaultMessage: 'RETURN ADDRESS'
    },
    orderDate: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.ORDER DATE',
        defaultMessage: 'ORDER DATE'
    },
    returnDate: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.RETURN DATE',
        defaultMessage: 'RETURN DATE'
    },
    vendorName: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.VENDOR NAME',
        defaultMessage: 'VENDOR NAME'
    },
    returnInformation: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Return Information',
        defaultMessage: 'Return Information'
    },
    emailAddress: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.EMAIL ADDRESS',
        defaultMessage: 'EMAIL ADDRESS'
    },
    telephone: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.TELEPHONE #',
        defaultMessage: 'TELEPHONE #'
    },
    homeOwnership: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.HOMEOWNERSHIP',
        defaultMessage: 'HOMEOWNERSHIP'
    },
    timeAtResidence: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.TIME AT RESIDENCE',
        defaultMessage: 'TIME AT RESIDENCE'
    },
    drivers: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Drivers',
        defaultMessage: 'Drivers'
    },
    noInfo: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.noInfo',
        defaultMessage: 'No information is available to display'
    },
    driver: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.DRIVER',
        defaultMessage: 'DRIVER'
    },
    dob: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.DATE OF BIRTH',
        defaultMessage: 'DATE OF BIRTH'
    },
    gender: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.GENDER',
        defaultMessage: 'GENDER'
    },
    maritalStatus: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.MARITAL STATUS',
        defaultMessage: 'MARITAL STATUS'
    },
    license: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.LICENSE #',
        defaultMessage: 'LICENSE #'
    },
    licenseNumberMask: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.licenseNumberMask',
        defaultMessage: '****'
    },
    vin: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.vin',
        defaultMessage: 'Vehicle Identification Number'
    },
    licenseState: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.License State',
        defaultMessage: 'License State'
    },
    salvageTitle: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Salvage Title',
        defaultMessage: 'Salvage Title'
    },
    vehicleType: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Vehicle Type',
        defaultMessage: 'Vehicle Type'
    },
    usedForBusiness: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Used for Business',
        defaultMessage: 'Used for Business'
    },
    lienholderName: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Lienholder Name',
        defaultMessage: 'Lienholder Name'
    },
    lienholderAddress: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.Lienholder Address',
        defaultMessage: 'Lienholder Address'
    },
    secondLienholderName: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.2nd Lienholder Name',
        defaultMessage: '2nd Lienholder Name'
    },
    secondLienholderAddress: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorsPrefill.2nd Lienholder Address',
        defaultMessage: '2nd Lienholder Address'
    }
});